(function () {
    'use strict';

    angular.module('thankview.global')
        .factory('smoothScroll', ['$timeout', '$window', function ($timeout, $window) {
            var smoothScroll = {};

            smoothScroll.scrollTo = function (stopAt) {
                // This scrolling function
                // is from http://www.itnewb.com/tutorial/Creating-the-Smooth-Scroll-Effect-with-JavaScript

                var currentYPosition = function () {
                    // Firefox, Chrome, Opera, Safari
                    if ($window.pageYOffset) {
                        return $window.pageYOffset;
                    }
                    return 0;
                };

                var timeoutScrollTo = function () {
                    $window.scrollTo(0, this);
                };

                var startY = currentYPosition();
                var stopY = stopAt;
                var distance = stopY > startY ? stopY - startY : startY - stopY;
                if (distance < 100) {
                    $window.scrollTo(0, stopY);
                    return;
                }
                var speed = Math.round(distance / 100);
                if (speed >= 20) speed = 20;
                var step = Math.round(distance / 50);
                var leapY = stopY > startY ? startY + step : startY - step;
                var timer = 0;
                if (stopY > startY) {
                    for (let i = startY; i < stopY; i += step) {
                        $timeout(timeoutScrollTo.bind(leapY), (timer * speed));
                        leapY += step;
                        if (leapY > stopY) {
                            leapY = stopY;
                        }
                        timer += 1;
                    }
                    return;
                }
                for (let i = startY; i > stopY; i -= step) {
                    $timeout(timeoutScrollTo.bind(leapY), (timer * speed));
                    leapY -= step;
                    if (leapY < stopY) {
                        leapY = stopY;
                    }
                    timer += 1;
                }
            };

            return smoothScroll;
        }]);
}());
